import { describe, it, expect } from 'vitest';
import { createMandateErrorHandler } from './error-hander';

describe(createMandateErrorHandler, () => {
  describe('main page (isSuccessPage: false)', () => {
    it('should throw mandate_expired error for payment_link_expired code', () => {
      const handler = createMandateErrorHandler({ isSuccessPage: false });
      const error = {
        status: 400,
        data: { errors: [{ code: 'payment_link_expired' }] },
      };

      expect(() => {
        handler(error);
      }).toThrow('mandate_expired');
    });

    it('should throw mandate_invalid error for 412 status', () => {
      const handler = createMandateErrorHandler({ isSuccessPage: false });
      const error = {
        status: 412,
        data: { errors: [{ code: 'mandate_already_signed' }] },
      };

      expect(() => {
        handler(error);
      }).toThrow('mandate_invalid');
    });

    it('should throw mandate_invalid error for 404 status', () => {
      const handler = createMandateErrorHandler({ isSuccessPage: false });
      const error = {
        status: 404,
        data: { errors: [{ code: 'mandate_not_found' }] },
      };

      expect(() => {
        handler(error);
      }).toThrow('mandate_invalid');
    });

    it('should throw generic_error for other errors', () => {
      const handler = createMandateErrorHandler({ isSuccessPage: false });
      const error = {
        status: 500,
        message: 'Internal server error',
      };

      expect(() => {
        handler(error);
      }).toThrow('generic_error');
    });

    it('should throw generic_error for non-HTTP errors', () => {
      const handler = createMandateErrorHandler({ isSuccessPage: false });
      const error = new Error('Network error');

      expect(() => {
        handler(error);
      }).toThrow('generic_error');
    });
  });

  describe('success page (isSuccessPage: true)', () => {
    it('should not throw error for 412 status (mandate already signed)', () => {
      const handler = createMandateErrorHandler({ isSuccessPage: true });
      const error = {
        status: 412,
        data: { errors: [{ code: 'mandate_already_signed' }] },
      };

      expect(() => {
        handler(error);
      }).not.toThrow();
    });

    it('should throw mandate_invalid error for 412 status with other codes', () => {
      const handler = createMandateErrorHandler({ isSuccessPage: true });
      const error = {
        status: 412,
        data: { errors: [{ code: 'mandate_expired' }] },
      };

      expect(() => {
        handler(error);
      }).toThrow('mandate_invalid');
    });

    it('should throw mandate_invalid error for 404 status (mandate not found)', () => {
      const handler = createMandateErrorHandler({ isSuccessPage: true });
      const error = {
        status: 404,
        data: { errors: [{ code: 'mandate_not_found' }] },
      };

      expect(() => {
        handler(error);
      }).toThrow('mandate_invalid');
    });

    it('should throw mandate_expired error for payment_link_expired code', () => {
      const handler = createMandateErrorHandler({ isSuccessPage: true });
      const error = {
        status: 400,
        data: { errors: [{ code: 'payment_link_expired' }] },
      };

      expect(() => {
        handler(error);
      }).toThrow('mandate_expired');
    });

    it('should throw mandate_invalid error for 400 status with other codes', () => {
      const handler = createMandateErrorHandler({ isSuccessPage: true });
      const error = {
        status: 400,
        data: { errors: [{ code: 'invalid_request' }] },
      };

      expect(() => {
        handler(error);
      }).toThrow('mandate_invalid');
    });

    it('should throw generic_error for other errors', () => {
      const handler = createMandateErrorHandler({ isSuccessPage: true });
      const error = {
        status: 500,
        message: 'Internal server error',
      };

      expect(() => {
        handler(error);
      }).toThrow('generic_error');
    });
  });

  describe('edge cases', () => {
    it('should handle null/undefined errors', () => {
      const handler = createMandateErrorHandler({ isSuccessPage: false });

      expect(() => {
        handler(null);
      }).toThrow('generic_error');
      expect(() => {
        handler(undefined);
      }).toThrow('generic_error');
    });

    it('should handle errors without status', () => {
      const handler = createMandateErrorHandler({ isSuccessPage: false });
      const error = { message: 'Some error' };

      expect(() => {
        handler(error);
      }).toThrow('generic_error');
    });

    it('should handle errors without errors array', () => {
      const handler = createMandateErrorHandler({ isSuccessPage: false });
      const error = { status: 412 };

      expect(() => {
        handler(error);
      }).toThrow('mandate_invalid');
    });
  });
});
